function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
window.onload = function() {
  if(document.querySelector('.product-form__submit .variant-price') && document.querySelector('.rc-radio--active .price-label')){
    document.querySelector('.product-form__submit .variant-price').innerHTML = document.querySelector('.rc-radio--active .price-label').innerHTML
  }
};
$(document).on('click', '.rc-radio', function() {
  if(document.querySelector('.product-form__submit .variant-price') && this.querySelector('.price-label')){
    document.querySelector('.product-form__submit .variant-price').innerHTML = this.querySelector('.price-label').innerHTML
  }
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.select = this.querySelector('select');
    
    if(this.select) {
      this.select.addEventListener('change', () => {
        var value = parseInt(this.select.value);
        this.input.value = value;
      })
    }
    
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    document.querySelector('body').classList.remove('overflow-hidden-small');
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.querySelector('body').classList.add('overflow-hidden-small');
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
  }
}

customElements.define('header-drawer', HeaderDrawer);


class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    if(this.getAttribute('open')) return;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);
if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';
      
      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
          
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
    }
    
    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }
  });
}
class SelectModal extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    
    var productId = this.getAttribute('data-product-id');
    if(!this.querySelector('.minicart-form')) {
      if (this.querySelector("button")) {
        this.querySelector("button").addEventListener("click", (e) => {
          setTimeout(this.hide(), 1000);
        })
      }
      
    }

    // if (window.matchMedia('(min-width: 768px)').matches) {
    //   var option = this.querySelectorAll('.radio-custom.color');
    //   if(option.length > 7) {
    //     for(var i = 0; i < option.length; i++) {
    //       if(i > 7) {
    //         option[i].classList.add('hidden');
    //       }
    //     }
    //   } else {
    //     if (this.querySelector(".extra-color")) {
    //       this.querySelector(".extra-color").style.display = 'none';
    //     }
    //   }
    // }
    
    // const extraColors = document.querySelectorAll(".radio-custom.extra-color");

    // if (extraColors.length > 0) {
    //   extraColors.forEach((extraColor) => {
    //     extraColor.addEventListener("click", (event) => {
    //       event.stopPropagation();
    //       event.preventDefault();
          
    //       const parent = event.currentTarget.closest(".radio");
    //       const option = parent.querySelectorAll(".radio-custom.color");
          
    //       if (option) {
    //         option.forEach((e) => {
    //           e.classList.remove("hidden");
    //           e.classList.add("extra-click");
    //         });
    //         event.currentTarget.style.display = 'none';
    //       }
    //     });
    //   });
    // }

    if(this.querySelector('input[type="radio"]')) {
      if(!this.querySelector('input[type="radio"]:checked')) {
        this.querySelectorAll('input[type="radio"]')[0].checked = true;
        this.querySelectorAll('input[type="radio"]')[0].setAttribute('checked','');
      };
      this.querySelectorAll('input[type="radio"]').forEach((option) => {
        if(option.hasAttribute('checked')) {
          if(this.querySelector('button[type="submit"] .variant-price')) {
            this.querySelector('button[type="submit"] .variant-price').innerHTML = option.getAttribute('data-price');
          }
          if(document.querySelector('.cross-sell .variant-price')) {
            document.querySelector('.cross-sell .variant-price').innerHTML = option.getAttribute('data-price');
          }
        };
        option.addEventListener('click', () => {
          var available = option.getAttribute('data-available');

          if(available == 'true') {
            this.querySelector('button[type="submit"]').removeAttribute("disabled");
            this.querySelector('button[type="submit"] .add-cart-text').innerHTML = this.querySelector('.add-cart-message').innerHTML;
          } else if (available == 'false') {
            this.querySelector('button[type="submit"]').setAttribute("disabled","");
            this.querySelector('button[type="submit"] .add-cart-text').innerHTML = this.querySelector('.sold-out-message').innerHTML;
          }
          if(this.querySelector('.radio-custom.color')) {
            document.querySelectorAll('.card-wrapper[data-id='+ '"' + productId + '"' +'] .card__media img').forEach((img) => {
              img.src = option.getAttribute('data-product-image');
              img.removeAttribute('srcset');
            });
            if(document.querySelector('.card__content[data-id='+ '"' + productId + '"' +'] .card__heading .full-unstyled-link')){
              document.querySelector('.card__content[data-id='+ '"' + productId + '"' +'] .card__heading .full-unstyled-link').innerHTML = option.getAttribute('data-product-title');
            }
            if(document.querySelector('.card__content[data-id='+ '"' + productId + '"' +'] .card__description') && option.getAttribute('data-product-description')) {
              document.querySelector('.card__content[data-id='+ '"' + productId + '"' +'] .card__description').innerHTML = option.getAttribute('data-product-description');
            }
            if (document.querySelector('.card-wrapper[data-id='+ '"' + productId + '"' +'] .product-grid-item__info-variant-title')) {
              document.querySelector('.card-wrapper[data-id='+ '"' + productId + '"' +'] .product-grid-item__info-variant-title').innerHTML = option.getAttribute('data-variant-title');
            }
          }
          if(this.querySelector('button[type="submit"] .variant-price')) {
            this.querySelector('button[type="submit"] .variant-price').innerHTML = option.getAttribute('data-price');
          }
          
          if(this.parentElement.parentElement.querySelector('.card__content .card__price')) {
            this.parentElement.parentElement.querySelector('.card__content .card__price').innerHTML = option.getAttribute('data-price');
          }
          if(document.querySelector('.cross-sell .variant-price')) {
            document.querySelector('.cross-sell .variant-price').innerHTML = option.getAttribute('data-price');
          }
          this.querySelector('form').setAttribute('data-gwp-variant', option.getAttribute('data-gwp-variant'));
        });
      })
    }
  }

   show(opener) {
    this.openedBy = opener;

    if (window.matchMedia('(min-width: 750px)').matches) {
      if( this.closest('.card__content') ){
        if(this.closest('.card__content').querySelector('.card__description')) {
          this.closest('.card__content').querySelector('.card__description').classList.add("hidden");
        }
        if(this.closest('.card__content').querySelector('.card-information')) {
          this.closest('.card__content').querySelector('.card-information').classList.add("hidden");
        }
      }
      
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'SELECT-MODAL') this.hide();
      });
      this.setAttribute('open', 'opened');
      document.body.classList.add("slider-overflow");
    }
  }

  hide() {
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    document.body.classList.remove("slider-overflow");
    if( this.closest('.card__content') ){
    if(this.closest('.card__content').querySelector('.card__description')) {
      this.closest('.card__content').querySelector('.card__description').classList.remove("hidden");
    }
    if(this.closest('.card__content').querySelector('.card-information')) {
      this.closest('.card__content').querySelector('.card-information').classList.remove("hidden");
    }
  }
    removeTrapFocus(this.openedBy);
  }

  updateGWPVariantID() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    
    productForms.forEach((productForm) => {
      if (this.currentVariant.gwp_variant) {
        productForm.setAttribute('data-gwp-variant', this.currentVariant.gwp_variant);
      } else {
        productForm.removeAttribute('data-gwp-variant')
      }

    });
  }
  
}
customElements.define('select-modal', SelectModal);


class ModalOpener extends HTMLElement {
  constructor() {
    super();
    this.bindButtonLink();
    this.bindALink();
    
  }

  bindButtonLink() {

    var button = this.querySelector('button');
    
    if (button) {
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button);
      });
    }
  }

  bindALink() {
    var a = this.querySelector('a');

    if(a) {
      a.addEventListener('click', (e) => {
        e.preventDefault();
        const modal1 = document.querySelector(this.getAttribute('data-modal'));
        if (modal1) modal1.show(a);
      });
    }
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      this.querySelector('template').content.firstElementChild.setAttribute("data-ot-ignore", "");
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SwatchImage extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll(".product-swatch-large-small img").forEach((swatch) => swatch.addEventListener("click", this.changeContent.bind(this)));
  }

  changeContent(e) {
    this.data = e.target;
    this.querySelectorAll(".product-swatch-large-small img").forEach((swatch) => swatch.classList.remove("active"));
    e.target.classList.add("active")
    this.querySelector(".image-featured-product img").src = this.data.getAttribute("data-main-img");
    this.querySelector(".product-swatch-large-image img").src = this.data.getAttribute("data-image");
    this.querySelector(".description-product").innerHTML = this.data.getAttribute("data-short-des");
    this.querySelector(".title-product").innerHTML = this.data.getAttribute("data-title");
    this.querySelector(".button-product-desktop a").href = this.data.getAttribute("data-url");
    this.querySelector(".button-product-mobile a").href = this.data.getAttribute("data-url");
  }
}

customElements.define('swatch-section', SwatchImage);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }
  isSlideMiddle(element) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft;

    if (element.offsetLeft == this.slider.scrollLeft) {
      return "first";
    }
    
    if (lastVisibleSlide == element.clientWidth + element.offsetLeft) {
      return "last";
    }
    
    return "middle";
  }
  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);
function waitFor(variable, callback) {
  var interval = setInterval(function() {
    if (window[variable]) {
      clearInterval(interval);
      callback();
    }
  }, 200);
}
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    if (window.Recharge) {
      var product_id = this.getAttribute('data-id');
      window.Recharge.widgets[product_id].config.initialVariantId = this.getAttribute("data-variant-id");
    }
    document.addEventListener("DOMContentLoaded" , this.init.bind(this));
  }

  init() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantTitle();
    this.updateMediaViewer();

    this.updateGWPVariantID();
    
    if (window.Recharge) {
      this.updateRc();
    }
  }

  updateRc() {
    document.querySelectorAll('.rc-radio__input').forEach((button) => {
      button.addEventListener("input", (e) => {
        document.querySelectorAll('.product-form__submit .variant-price').forEach((price) => {
          price.innerHTML = button.parentElement.querySelector(".price-label").innerHTML
        })
      })
    })
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateGWPVariantID();

    this.updateVariantInput();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      if (!document.querySelector('.bundle-products')) {
        this.updateMedia();
        this.updateMediaViewer();
        this.updateMediaThumb();
        if (this.getAttribute("data-quiz-result")) {
        } else {
          this.updateURL();
        }
        this.updateVariantReview()
      } else {
        this.setAttribute('data-variant-id', this.currentVariant.id);
      }
      this.updateVariantTitle();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }



  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateGWPVariantID() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    
    productForms.forEach((productForm) => {
      if (this.currentVariant.gwp_variant) {
        productForm.setAttribute('data-gwp-variant', this.currentVariant.gwp_variant);
      } else {
        productForm.removeAttribute('data-gwp-variant')
      }

    });
  }

  updateVariantReview() {
    if (document.querySelector('#pr-reviewdisplay .pr-snippet-read-and-write .pr-snippet-write-review-link')) {
      var link = document.querySelector('#pr-reviewdisplay .pr-snippet-read-and-write .pr-snippet-write-review-link').getAttribute('href');
      link = link.split('&');
      var newLink = '';
      link.forEach((child) => {
        if (child.includes('pr_page_id_variant')) {
          newLink += '&pr_page_id_variant=' + this.currentVariant.id;
        } else {
          if(child != link[0]) {
            newLink += '&' + child;
          } else {
            newLink += child;
          }
        }
      })
      var newItem = document.createElement('div');
      newItem.className = "button-write-review"
      newItem.innerHTML = '<a href="' + newLink + '" class="pr-snippet-write-review-link pr-underline">Write a Review</a>';
      if(document.querySelector('#pr-reviewdisplay .pr-snippet-read-and-write .pr-snippet-write-review-link').closest('.button-write-review')) {
        document.querySelector('#pr-reviewdisplay .pr-snippet-read-and-write .button-write-review').innerHTML = '<a href="' + newLink + '" class="pr-snippet-write-review-link pr-underline">Write a Review</a>';
      } else {
        document.querySelector('#pr-reviewdisplay .pr-snippet-read-and-write .pr-snippet-write-review-link').parentNode.replaceChild(newItem, document.querySelector('#pr-reviewdisplay .pr-snippet-read-and-write .pr-snippet-write-review-link'));
      }
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (mediaGallery) {
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateMediaViewer() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleryViewer = document.getElementById(`GalleryViewer-${this.dataset.section}`);
    const alt = this.currentVariant.title;
    var productName = this.currentVariant.name.replace(" - " + alt, "");
    if(mediaGalleryViewer && window.innerWidth < 768) {
      mediaGalleryViewer.querySelectorAll('li').forEach((thumb) => {
        if (thumb.getAttribute('data-media') != productName && !thumb.classList.contains('is-active')) {
          if (thumb.getAttribute('data-media') == alt) {
            thumb.classList.remove('small-hide');
          } else {
            thumb.classList.add('small-hide');
          }
        } else {
          thumb.classList.remove('small-hide');
        }
      })
    }
  }

  updateMediaThumb() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleryThumb = document.getElementById(`GalleryThumbnails-${this.dataset.section}`);
    const alt = this.currentVariant.title;
    var productName = this.currentVariant.name.replace(" - " + alt, "");
    if(mediaGalleryThumb) {
      mediaGalleryThumb.querySelectorAll('li').forEach((thumb) => {
        if (thumb.getAttribute('data-media') != productName) {
          if (thumb.getAttribute('data-media') == alt) {
            thumb.classList.remove('hidden');
          } else {
            thumb.classList.add('hidden');
          }
        } else {
          thumb.classList.remove('hidden');
        }
      })
    }
  }

  updateVariantTitle() {
    if (this.querySelector('.option-name')) {
      this.querySelector('.option-name').innerHTML = this.currentVariant.title;
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;

      if (this.currentVariant.gwp_variant) {
        productForm.setAttribute('data-gwp-variant', this.currentVariant.gwp_variant);
      } else {
        productForm.removeAttribute('data-gwp-variant')
      }

      input.dispatchEvent(new Event('change', { bubbles: true }));
      if (this.getAttribute("data-quiz-result")) {
        var select = productForm.querySelector("select");
        select.options[select.selectedIndex].removeAttribute("selected")
        const option = productForm.querySelector(`option[value="${this.currentVariant.id}"]`);
        option.setAttribute("selected", "selected") ;
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    );
  }
  
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
    if (!document.querySelector('.bundle-products')) {
      if (document.querySelector('.rc-radio--active.subscription-radio')) {
        document.querySelectorAll('.product-form__submit .variant-price').forEach((price) => {
          price.innerHTML = document.querySelector('.rc-radio--active .price-label').innerHTML
        })
      }
      else {
        if(document.querySelector('.product .price--on-sale')) {
          document.querySelectorAll('.product-form__submit .variant-price').forEach((price) => {
            price.innerHTML = document.querySelector('.price-item.price-item--sale').innerHTML
          })
          if (document.querySelectorAll('.product-form__submit .compare-at-price')) {
            document.querySelectorAll('.product-form__submit .compare-at-price').forEach((price) => {
              price.innerHTML = document.querySelector('.price__sale .price-item.price-item--regular').innerHTML
            })
          }
        } else {
          document.querySelectorAll('.product-form__submit .variant-price').forEach((price) => {
            price.innerHTML = document.querySelector('.price-item.price-item--regular').innerHTML
          }) 
        }
      }
    } else {
      if(document.querySelector('.product .price--on-sale')) {
        document.querySelectorAll('.product-form__submit .compare-at-price').forEach((price) => {
          price.innerHTML = document.querySelector('.price__sale .price-item.price-item--regular').innerHTML
        })
      }
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || window.global_variable || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      var input = Array.from(fieldset.querySelectorAll('input'));
      if (input.find((radio) => radio.checked) != undefined) {
        return input.find((radio) => radio.checked).value;
      } 
      if (input[0]) {
        input[0].click();
        return input[0].value
      }
    });
  }
}

customElements.define('variant-radios', VariantRadios);
// Variant Swatch
class VariantSwatch extends VariantSelects {
  constructor() {
    super();
  }

   onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.setUnavailable();
    } else {
      this.updateMedia();
    }
  }
  
  updateMedia() {
    this.querySelector(".product__media img").src = this.currentVariant.featured_image.src;
    this.querySelector(".product__media img").srcset = this.currentVariant.featured_image.src;
    if (this.querySelector(".featured-product-text.caption strong")) {
      this.querySelector(".featured-product-text.caption strong").textContent = this.currentVariant.title;
    }
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-swatch', VariantSwatch);
function masonryColMenu() {
  if(document.querySelectorAll('.mansonry-menu')) {
    document.querySelectorAll('.mansonry-menu').forEach((item) => {
      var msr = new Masonry( item, {
        itemSelector: '.col-12',
        columnWidth: '.grid-sizer',
        percentPosition: true
      });   
    })
  }
}
document.addEventListener('DOMContentLoaded', () => {
  masonryColMenu();
  window.addEventListener('resize', () => {
    masonryColMenu();
  });
  if(document.querySelector('#checkout')) {
    document.querySelector('#checkout').addEventListener('click', () => {
      const config = fetchConfig('javascript');
      var formData = {
        "items" : []
      };
      const variants = localStorage.getItem('sample-product').split(',');
      for(let i = 0; i < variants.length; i++) {
        formData.items.push({
          'id': parseInt(variants[i]),
          'quantity': 1
        });
      }
      fetch(`${routes.cart_add_url}`, { ...config, body: JSON.stringify(formData)})
      .then((response) => response.json())
      .catch((e) => {
        console.error(e);
      }).finally(() => {
        localStorage.removeItem('sample-product');
      });
    })
  }
  if(document.querySelector('#Slider-account-tab')) {
    document.querySelectorAll('[id^="Slide-account-tab-"]').forEach((tab) => {
      tab.addEventListener('click', () => {
        document.querySelector('.slider__slide.active').classList.remove('active');
        tab.classList.add('active');
        document.querySelector('.account-tab.active').classList.remove('active');
        document.querySelector('.account-tab[aria-tab="'+ tab.getAttribute('id') +'"]').classList.add('active');
      })
    });
  }

})

function fireWhenReady() {
  if (typeof $.fn.slick != 'undefined') {
    $('.testimonials-wrapper').not(".slick-initialized").slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      arrows: true,
      prevArrow: '<i class="icon-chevron-left"></i>',
      nextArrow: '<i class="icon-chevron-right"></i>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
  else {
      setTimeout(fireWhenReady, 600);
  }
}
function slickCarousel() {
  $('.products-sample-wrapper .slider').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $('#sample-left'),
    nextArrow: $('#sample-right'),
    dots: false
  });
}

window.addEventListener('DOMContentLoaded', (event) => {
fireWhenReady();
  $(".section-testimonials")
    .on('shopify:section:load', fireWhenReady())
    .on('shopify:section:unload', fireWhenReady())
    .on('shopify:section:select', fireWhenReady())
    .on('shopify:section:deselect', fireWhenReady())
    .on('shopify:block:select', fireWhenReady())
    .on('shopify:block:deselect', fireWhenReady());
  
   if ($('.bundle-items__scrollable-container')) {
    $('.bundle-items__scrollable-container').not(".slick-initialized").slick({
      infinite: false,
      slidesToShow: 2.8,
      slidesToScroll: 1,
      arrows: false,
      dots: false
    });
  }  
});
window.addEventListener('shopify:section:load', (event) => {
  fireWhenReady();
    
});
var paymentButton = document.querySelector('.product-form__buttons')
if(paymentButton) {
  paymentButton.style.minHeight = paymentButton.clientHeight + 'px';
}

window.addEventListener("scroll", function() {
  var elementTarget = document.getElementById("show-sticky-button");
  var buttonFixedBottom = document.querySelector(".button-fixed-bottom");
  if(elementTarget && buttonFixedBottom) {
    if (window.scrollY > (elementTarget.offsetTop + elementTarget.offsetHeight)) {
        buttonFixedBottom.style.display = "block"
        buttonFixedBottom.style.bottom = "-1px"
        buttonFixedBottom.classList.remove('active');
    }else{
      document.querySelector(".button-fixed-bottom").style.bottom = "-100%"
      document.querySelector(".button-fixed-bottom").classList.add('active')
    }
    var elementTarget2 = document.getElementById("shopify-section-footer");
    if (window.scrollY > (elementTarget2.offsetTop )) {
      document.querySelector(".button-fixed-bottom").style.bottom = "-100%"
      document.querySelector(".button-fixed-bottom").classList.add('active')
    }
  }
  if (paymentButton) {
    if(window.innerWidth < 768) {
      if(paymentButton.getBoundingClientRect().top < 0) {
        paymentButton.classList.add('sticky');
      } else {
        paymentButton.classList.remove('sticky');
      }
    } else {
      paymentButton.classList.remove('sticky');
    }
  }
});
if(document.querySelector('.description-wrapper .read-more')) {
  document.querySelector('.description-wrapper .read-more').addEventListener('click', () => {
    if(document.querySelector('.description-wrapper .read-more.less')) {
      document.querySelector('.description').innerHTML = document.querySelector('.description-showless').innerHTML;
      document.querySelector('.description-wrapper .read-more').innerHTML = window.product.read_more;
      document.querySelector('.description-wrapper .read-more').classList.remove('less');
    } else {
      document.querySelector('.description').innerHTML = document.querySelector('.details-description').innerHTML;
      document.querySelector('.description-wrapper .read-more').innerHTML = window.product.show_less;
      document.querySelector('.description-wrapper .read-more').classList.add('less');
    }
  })
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    document.querySelector('.header-cart').addEventListener('click', (event) => {
      if (event.target === document.querySelector('.header-cart')) this.hide();
    });

  }
  show(opener, state = true) {
    this.classList.add('loading');
    document.querySelector('.header-cart').classList.add('active');
    document.body.classList.add('overflow-hidden');

    // Open cart with effect
    this.setAttribute('open', '');
    if (state) {
      this.updateCart();
    }
  }

  updateCart(data) {
     this.classList.add('loading');
     var url = '/cart?&view=ajax';
    fetch(url)
    .then(response => response.text())
    .then((text) => {
      const parsedHTML = new DOMParser().parseFromString(text, 'text/html');
      var pHtml = "";
      if (parsedHTML.querySelector('body')) {
        pHtml += parsedHTML.querySelector('body').innerHTML;
      }
      this.querySelector('.minicart-slideout-wrapper').innerHTML = pHtml;
      // this.querySelectorAll('.sample-quick-add ').forEach((button) => {
      //   if (button.getAttribute("data-variant-id") == localStorage.getItem('gift-product') || button.getAttribute("data-variant-id") == localStorage.getItem('gift-product-2')) {
      //     button.classList.remove('button--tertiary');
      //     button.querySelector('.added').classList.remove('hidden');
      //     button.querySelector('.add').classList.add('hidden');
      //     button.setAttribute('disabled', '');
      //   }
      // })
    }).finally(() => {
          var initial = 0;
          var animateHeader = false;
          var ua = window.navigator.userAgent;
          var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
          var webkit = !!ua.match(/WebKit/i);
          
          var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
          if (iOSSafari) {
            document.querySelector('.cart-ajax-item').style.maxHeight= 'calc(100vh - 350px)';
          }
      if (data) {
        document.getElementById('cart-icon-bubble').innerHTML = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section').innerHTML;
        document.getElementById('cart-icon-bubble').bindALink();
      }
      slickCarousel();
      this.classList.remove('loading');
    });
    
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.querySelector('.header-cart').classList.remove('active');
    this.removeAttribute('open');
  }
}
customElements.define('cart-drawer', CartDrawer);

class CustomerDrawer extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    document.querySelector('.header-customer').addEventListener('click', (event) => {
      if (event.target === document.querySelector('.header-customer')) this.hide();
    });

    
  } 
  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    document.querySelector('.header-customer').classList.add('active');
    this.setAttribute('open', '');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.querySelector('.header-customer').classList.remove('active');
    this.removeAttribute('open');
  }
}
customElements.define('customer-drawer', CustomerDrawer);

window.addEventListener('load', (event) => {
  if( location.href.includes('/cart') ) {
    location.replace("https://www.dphue.com/?return_url=checkout")
  };
});